import React, { useEffect, useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { CreatableSelect } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import SpacePicker from "../../../../../../../components/ui/space-picker/SpacePicker";
import ContributorsPicker from "../../../../../../../components/ui/people-picker/ContributorsPicker";
import PagePicker from "../../../../../../../components/ui/page-picker/PagePicker";
import { usePagesStore } from "../../../../../../../stores/use-page-store";

const createOption = (label) => ({
  label,
  value: label,
});

function Dynamic() {
  const { t } = useTranslation();

  const { data, selectedTab, updateConfigTab } = usePagesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const [labels, setLabels] = useState([]);
  const [inputValue, setInputValue] = useState(undefined);

  useEffect(() => {
    if (data.config.tabs[selectedTab].labels) {
      setLabels(
        data.config.tabs[selectedTab].labels.map((l) => createOption(l))
      );
    }
  }, [data.config.tabs[selectedTab].labels]);

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setInputValue("");
        setLabels([...labels, createOption(inputValue)]);
        updateConfigTab({
          value: {
            labels: [
              ...data.config.tabs[selectedTab].labels,
              createOption(inputValue),
            ].map((l) => l.label),
          },
        });
        event.preventDefault();
        break;
      default:
        return;
    }
  };

  return (
    <>
      <SettingsOptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("spaces")}</OptionLabel>
          <OptionContent full>
            <SpacePicker
              initialSpaces={data.config.tabs[selectedTab].spaces}
              placeholder={t("select-spaces")}
              isMulti
              onUpdate={(value) => {
                updateConfigTab({ value: { spaces: value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("contributors")}</OptionLabel>
          <OptionContent full>
            <ContributorsPicker
              initialAccountIDs={data.config.tabs[selectedTab].contributors}
              isMulti
              placeholder={t("select-contributors")}
              onUpdate={(value) => {
                updateConfigTab({ value: { contributors: value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("show-subpages-of-these-pages")}</OptionLabel>
          <OptionContent full>
            <PagePicker
              loadInitialOptions
              placeholder={t("select-pages")}
              selectedPages={[data.config?.tabs[selectedTab]?.parentPage]}
              isSubPages={true}
              onSelect={(selectedPage) =>
                updateConfigTab({
                  value: {
                    parentPage: selectedPage ? selectedPage.contentId : null,
                  },
                })
              }
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("labels")}</OptionLabel>
          <OptionContent full>
            <CreatableSelect
              inputValue={inputValue}
              isClearable
              isMulti
              onChange={(newLabels) => {
                setLabels(newLabels);
                updateConfigTab({
                  value: {
                    labels: newLabels.map((l) => l.label),
                  },
                });
              }}
              placeholder={t("select-labels")}
              menuIsOpen={false}
              onInputChange={(newValue) => setInputValue(newValue)}
              onKeyDown={handleKeyDown}
              hideDropdownIcon
              value={labels}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default Dynamic;
